import { RouterModule, Routes } from "@angular/router";
import { FindByTicketComponent } from "./pages/find-by-ticket/find-by-ticket.component";
import { MasGarantiaComponent } from "./pages/mas-garantia/mas-garantia.component";
import { NgModule } from "@angular/core";


const routes: Routes = [
    { path: '',pathMatch: 'full', component: MasGarantiaComponent, children:[
        { path: 'findbyticket', pathMatch: 'full', component: FindByTicketComponent }
    ]},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MasGarantiaRoutingModule {}